import { Notify } from '@flexisaf/flexibull2';
import { put, takeLatest } from 'redux-saga/effects';

import { TOP_RIGHT, SUCCESS } from 'utils/constants';
import request from 'utils/request';
import urls from 'utils/config';

import { deactivateFormsSuccess, deactivateFormsFailure } from '../actions';
import FormsActionTypes from '../types';
import { networkErrorHandler } from 'utils/errrorHandlers';

const { FORM_API_BASE_URL } = urls || {};

function* deactivateForm({ id, status }) {
  const payload = {
    active: status,
  };
  const url = `${FORM_API_BASE_URL}/designs/${id}`;

  const response = yield request({
    method: 'patch',
    data: payload,
    url,
  });
  if (response.success) {
    Notify(`Form Deactivated Successfully`, {
      position: TOP_RIGHT,
      status: SUCCESS,
    });
    yield put(deactivateFormsSuccess(response.raw));
  } else {
    yield put(deactivateFormsFailure(response.message));
    networkErrorHandler(response?.statusCode, response?.message);
  }
}

export function* onFormDeactivate() {
  yield takeLatest(FormsActionTypes.START_DEACTIVATE_FORM, deactivateForm);
}
